import React, { FC, ReactNode } from 'react';
import { Grid, IconButton, TableRow, TableCell } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { Group } from 'api';
import { CustomSVG } from 'components';
import { generateLink } from 'Links';

import ImageCell from '../GroupCells/Image';
import TitleCell from '../GroupCells/Title';
import MembersCell from '../GroupCells/Members';

const styles = (theme: Theme) =>
  createStyles({
    row: {
      '&:nth-child(even)': {
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.custom.palette.grey5}`,
      },
    },
  });

interface IProps extends WithStyles<typeof styles> {
  role: ReactNode;
  group: Group;
}

const OwnerRow: FC<IProps> = ({ classes, group, role }) => (
  <TableRow className={classes.row} key={group.id}>
    <TableCell>
      <Grid container alignItems="center" wrap="nowrap" spacing={2}>
        <ImageCell group={group} />
        <TitleCell group={group} />
      </Grid>
    </TableCell>
    <TableCell align="center">
      <MembersCell group={group} />
    </TableCell>
    <TableCell align="center">{role}</TableCell>
    <TableCell align="center">
      <IconButton component={generateLink(`/group/${group.id}/edit`)}>
        <CustomSVG name="pencil" />
      </IconButton>
    </TableCell>
  </TableRow>
);

export default withStyles(styles)(OwnerRow);
